import React from "react";

import { Label, Control, Input, Column } from "rbx";
import PropTypes from "prop-types";
import { BooleanInput } from "../inputs";

const PaymentTermForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Column.Group>
      <Column size={5}>
        <Control>
          <Label>Code</Label>
          <Input
            expanded
            required
            autocomplete="new"
            name="TermCode"
            type="text"
            value={inputs?.TermCode}
            onChange={onChange}
          />
        </Control>
      </Column>
      <Column size={7}>
        <Control>
          <Label>Description</Label>
          <Input
            expanded
            required
            autocomplete="new"
            name="TermDescription"
            type="text"
            value={inputs?.TermDescription}
            onChange={onChange}
          />
        </Control>
      </Column>
    </Column.Group>
    <Column.Group>
      <Column size={5}>
        <Control>
          <Label>Days</Label>
          <Input
            required
            autocomplete="new"
            name="TermDays"
            type="number"
            value={inputs?.TermDays}
            onChange={onChange}
          />
        </Control>
      </Column>
      <Column size={5}>
        <Control>
          <Label>Discount</Label>
          <Input
            required
            autocomplete="new"
            name="TermDiscount"
            type="number"
            value={inputs?.TermDiscount}
            onChange={onChange}
          />
        </Control>
      </Column>
      <Column size={2}>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={onChange}
          />
        </Control>
      </Column>
    </Column.Group>
  </React.Fragment>
);

PaymentTermForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

export default PaymentTermForm;
